<template>
  <div class="app-container">
    <navigation :title="headerTitle"></navigation>
    <div class="content">
      <van-tabs :ellipsis="false"  title-inactive-color="#333"  @click="tabClick">
        <van-tab v-for="item in tabClass" :title="item" :name='item'>
          <div class="filter" v-if="headerTitle === '讲座预告'">
            <van-field readonly clickable name="picker" :value="value" placeholder="点击选择" @click="showPicker = true">
              <template #right-icon>
                <svg-icon iconClass='arrow-grey' className='icon'></svg-icon>
              </template>
            </van-field>
            <van-popup v-model="showPicker" position="bottom">
              <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false"/>
            </van-popup>
          </div>
          <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
          >
            <van-cell v-for="item in list" @click="goDetail(item.id,item.noticeType)">
              <template #title>
                <div class="message-tit">{{ item.title }}</div>
                <div class="message-tit message-tit-right" v-if="item.subTitle">{{ item.subTitle }}</div>
              </template>
              <template #label>
                <div class="time">
                  <span v-if='(item.startTime || "").split(" ")[0]===(item.endTime || "").split(" ")[0]'>{{item.startTime.split(' ').join(' '+item.startWeek+' ')}}-{{(item.endTime || "").split(' ')[1]}}</span>
                  <span v-else-if="item.endTime">{{ item.startTime.split(' ').join(' '+item.startWeek+' ') }}—{{ item.endTime.split(' ').join(' '+item.endWeek+' ') }}</span>
                  <span  v-else-if="headerTitle==='展览预告' || headerTitle==='培训预告'">{{ item.startTime+' '+item.startWeek }} 起</span>
                  <span v-else>{{ item.startTime.split(' ').join(' '+item.startWeek+' ') }}</span>
                </div>
              </template>
            </van-cell>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
    <version></version>
    <van-overlay :show="show" :lock-scroll="false">
      <div class="wrapper" @click.stop>
        <div class="prompt">
          <div class="prompt-content">
            <div class="prompt-title">温馨提示：<van-icon name="close" class="close" @click="closePrompt"/></div>
            <div class="prompt-message">{{ prompt }}</div>
          </div>
          <div class='isPrompt'>
            <van-checkbox v-model="checked" icon-size="16px">今日不再提示</van-checkbox>
          </div>
        </div>
      </div>
    </van-overlay>
    <scroll></scroll>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, List, Icon, Checkbox, Overlay } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'
import scroll from '../../components/scroll'
import {parseTime} from '../../untils/formatTime'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox).use(Overlay)
export default {
  name: 'lecture',
  components: {navigation, version,scroll},
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      checked: false,
      choose: true,
      checkAll: false,
      ifManagement: true,
      show: true,
      prompt: '',
      tabClass: ['全部'],
      params: {
        pageNum: 1,
        pageSize: '10',
        placeRegion: ''
      },
      headerTitle: this.$route.query.title,
      value: '所有栏目',
      showPicker: false,
      columns: ['所有栏目']
    }
  },
  created () {
    console.log('this.headerTitle',this.headerTitle)
    // 是否显示温馨提示弹框
    this.init()
    // 温馨提示内容
    this.getReminder()
    // tab分类
    this.getTab()
    document.body.style.overflow = 'hidden'
  },
  methods: {
    // 获取分类列表
    getType () {
      let params = {
        placeRegion: this.params.placeRegion
      }
      request('get', '/nlc-web/api/nlcNotice/lectureType',params).then(res => {
        console.log('筛选分类', res)
        res.data.forEach( item => {
          this.columns.push(item)
        })
      })
    },
    // 选择分类
    onConfirm (value) {
      console.log('value',value)
      this.value = value
      this.showPicker = false
      this.params.pageNum = '1'
      this.list = []
      if(value==='所有栏目'){
        delete this.params.lectureType
        this.onLoad()
      } else {
        this.onLoad(value)
      }
    },
    // 是否显示温馨提示弹框
    init () {
      var prompt = this.$cookies.get('prompt')
      if (prompt) {
        this.show = false
        document.body.style.overflow = 'scroll'
      }
    },
    // 返回上一页
    onClickLeft () {
      this.$router.go(-1)
    },
    // 加载数据列表
    onLoad (filter) {
      if(this.params.placeRegion==='全部') {
        this.params.placeRegion = ''
      }
      if(filter){
        this.params.lectureType = filter
      }
      this.params.pageNum = '' + this.params.pageNum + ''
      if (this.headerTitle === '讲座预告') {
        this.params.noticeType = 'NOTICE_LECTURE'
      } else if (this.headerTitle === '展览预告') {
        this.params.noticeType = 'NOTICE_EXHIBITION'
      } else if (this.headerTitle === '演出预告') {
        this.params.noticeType = 'NOTICE_SHOW'
      } else if (this.headerTitle === '培训预告') {
        this.params.noticeType = 'NOTICE_TRAIN'
      }
      console.log('this.params',this.params)
      request('get', '/nlc-web/api/nlcNotice/group', this.params).then(res => {
        console.log('列表', res)
        var data = ''
        if (this.headerTitle === '讲座预告') {
          data = res.data.NOTICE_LECTURE
        } else if (this.headerTitle === '展览预告') {
          data = res.data.NOTICE_EXHIBITION
        } else if (this.headerTitle === '演出预告') {
          data = res.data.NOTICE_SHOW
        } else if (this.headerTitle === '培训预告') {
          data = res.data.NOTICE_TRAIN
        }
        for (var i = 0; i < data.content.length; i++) {
          if(this.headerTitle === '展览预告' || this.headerTitle === '培训预告'){
            data.content[i].startTime = parseTime(data.content[i].startTime,'{y}-{m}-{d}')
            data.content[i].endTime = parseTime(data.content[i].endTime,'{y}-{m}-{d}')
          } else {
            data.content[i].startTime = parseTime(data.content[i].startTime,'{y}-{m}-{d} {h}:{i}')
            data.content[i].endTime = parseTime(data.content[i].endTime,'{y}-{m}-{d} {h}:{i}')
          }
          this.list.push(data.content[i])
        }
        // 加载状态结束
        this.loading = false
        if (data.totalElements === this.list.length) {
          this.finished = true
        }
      })
      this.params.pageNum++
    },
    // 关闭温馨提示弹框
    closePrompt () {
      this.show = false
      document.body.style.overflow = 'scroll'
      if (this.checked === true) {
        // 设置cookie值
        let date = new Date()
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000)
        this.$cookies.set('prompt', this.checked, date)
      }
    },
    // 获取分类
    getTab () {
      let params = {}
      if (this.headerTitle === '讲座预告') {
        params.noticeType = 'NOTICE_LECTURE'
      } else if (this.headerTitle === '展览预告') {
        params.noticeType = 'NOTICE_EXHIBITION'
      } else if (this.headerTitle === '演出预告') {
        params.noticeType = 'NOTICE_SHOW'
      } else if (this.headerTitle === '培训预告') {
        params.noticeType = 'NOTICE_TRAIN'
      }
      request('get', '/nlc-web/api/nlcNotice/venue', params).then(res => {
        console.log('tab分类', res)
        for (var i = 0; i < res.data.length; i++) {
          this.tabClass.push(res.data[i])
        }
        if (this.headerTitle === '讲座预告') {
          // 筛选分类
          this.getType ()
        }
      })
    },
    // 获取温馨提示
    getReminder () {
      var params = {
        noticeType: 'NOTICE_LECTURE'
      }
      request('get', '/nlc-web/api/nlcNotice/findReminder', params).then(res => {
        console.log('温馨提示', res)
        if (res.data.dictValue) {
          this.prompt = res.data.dictValue
        } else {
          this.show = false
          document.body.style.overflow = 'scroll'
        }
      })
    },
    // tab切换
    tabClick (name) {
      console.log('name', name)
      this.params.placeRegion = name
      this.params.pageNum = '1'
      this.list = []
      this.columns= ['所有栏目']
      this.value = '所有栏目'
      delete this.params.lectureType
      this.getType ()
      this.onLoad()
    },
    // 去详情页
    goDetail (id, type) {
      if (type === 'NOTICE_LECTURE') {
        this.$router.push({'name': 'exhibitionDetail', query: {id: id, title: '讲座详情', introduce: '讲座介绍'}})
      } else if (type === 'NOTICE_EXHIBITION') {
        this.$router.push({'name': 'exhibitionDetail', query: {id: id, title: '展览详情', introduce: '展览简介'}})
      } else if (type === 'NOTICE_SHOW') {
        this.$router.push({'name': 'exhibitionDetail', query: {id: id, title: '演出详情', introduce: '演出简介'}})
      } else if (type === 'NOTICE_TRAIN') {
        this.$router.push({'name': 'exhibitionDetail', query: {id: id, title: '培训详情', introduce: '培训简介'}})
      }
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  position:absolute;
  left:0;
  top:0;
  min-height:100%;
}
.wrapper{
  width: 100%;
  height: 100%;
  display:flex;
  align-items: center;
  justify-content: center;
}
.content{
  width: 6.94rem;
  margin:1.18rem .28rem .16rem .28rem;
  border-radius:8px;
  background:#fff;
  padding:.1rem 0;
}
.prompt{
  width: 4.9rem;
  background:#fff;
  font-size:.28rem;
  color:#47494c;
  border-radius:16px;
  padding:.34rem .3rem;
}
.prompt-content{
  width:100%;
  overflow:hidden;
}
.prompt-message{
  width:96%;
  padding:0 2%;
  height:3rem;
  overflow-y:scroll;
  white-space: pre-wrap;
  font-family: SourceHanSerifCN-Medium
}
.prompt-title{
  font-size:.36rem;
  position:relative;
  font-family: SourceHanSerifCN-SemiBold;
}
.close{
  position:absolute;
  right:.1rem;
  font-size:.36rem;
}
.isPrompt{
  width:72%;
  padding-left:28%;
  padding-top:.2rem;
}
.van-list >>>.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
}
.filter{
  margin:.24rem 0 .24rem .25rem;
}
.filter >>>.van-cell::after{
  border-bottom: none;
}
.filter >>>.van-field{
  width:3rem;
  height:.56rem;
  background:#fff;
  border-radius:30px;
}
.filter >>>.van-cell{
  padding: 0;
  line-height:.56rem;
}
.filter >>>.van-field__control{
  text-align: left;
  font-size: .24rem;
  padding-left: .25rem;
  color: #94979C;
}
.filter >>>.van-field__right-icon{
  margin-right:8px;
  padding:0 4px;
}
>>>.van-tab--active .van-tab__text{
  font-size:.36rem !important;
}
>>>.van-tab__text{
  font-size:.28rem;
  font-family: SourceHanSerifCN-SemiBold
}
.van-list .van-cell .van-cell__title{
  width:100%;
  font-size:.3rem;
  line-height:.4rem;
}
.van-list .van-cell .van-cell__label{
  font-size:.26rem;
}
.van-list .van-cell{
  padding:.1rem .3rem;
}
>>>.van-checkbox__label{
  line-height:.35rem;
  font-family: SourceHanSerifCN-Regular;
  color:#444649;
}
>>>.van-tabs__wrap {
  height: .65rem;
  margin-bottom:.1rem;
  padding-top:.1rem;
}
.time span{
  line-height:.33rem;
}
>>>.van-tabs__wrap--scrollable .van-tab{
  padding:0 .3rem;
}
>>>.van-tabs__nav--complete {
  padding-left: 0;
}
>>>.van-tabs__line{
  width:15%;
}
.message-tit{
  width:100%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  word-wrap:break-word;
}
.message-tit-right{
  text-align:right;
}
</style>



// WEBPACK FOOTER //
// src/view/lecture/index.vue